<template lang='pug'>
  div(@click='edit')
    div Repository:&nbsp;
      a(v-if='!repository' @click='edit') Set Repository
      a(@click='edit' target='_blank')
        strong {{repository}}
    v-checkbox(v-model='gitMode'
      :disabled='true'
      label='Git Mode Enabled')
    v-dialog(v-model='editing' max-width='500px')
      v-card
        v-card-title
          h3.text-h5.font-weight-light Edit GitHub Settings
        v-card-text
          v-select(v-model='repository' :items='repositories' label='Repository' required)
          v-checkbox(v-model='gitMode'
            label='Git Mode Enabled'
            persistent-hint
            hint='Used to source all modules and tests from a git repository. Only change these settings if you understand what you are doing')
        v-card-actions
          v-spacer
          v-btn(text @click='close()') Cancel
          v-btn(color='primary' @click='save' text :disabled='!repository' :loading='loading') Save
</template>

<script>
import {get} from 'lodash';
import {mapActions, mapGetters} from 'vuex';
import GitHub from '../api/github';
import Notifications from '../services/notification.service';

export default {
  name: 'GitHubConfig',
  async mounted() {
    this.repository = this.account.gitRepo;
    this.gitMode = this.account.gitMode;
    await this.loadRepositories();
  },
  computed: {
    hasEditAbility() {
      return get(this.user, 'superAdmin') || get(this.user, 'accountAdmin');
    },
    ...mapGetters({
      user: 'getUser',
      account: 'getAccount'
    })
  },
  methods: {
    async loadRepositories() {
      const list = await GitHub.repositories();
      this.repositories = list.map((it) => ({text: it.full_name, value: it.full_name}));
    },
    async save() {
      if (!(await Notifications.confirm('Save', 'Are you sure you want to edit git settings? This can cause major problems if you do not understand what you are doing.'))) return;
      this.loading = true;
      try {
        await GitHub.edit(this.repository, this.gitMode);
        await this.refreshUser(); // so our stored user/account reflects reality
        Notifications.toast('GitHub settings successfully updated.');
        this.editing = false;
      } catch (e) {
        Notifications.alert('There was a problem editing. Check console for details');
        console.error(e);
      } finally {
        this.loading = false;
      }
      console.log('save');
    },
    close() {
      this.editing = false;
    },
    edit() {
      if (!this.hasEditAbility) return;
      this.editing = true;
    },
    ...mapActions({refreshUser: 'refreshUser'})
  },
  data() {
    return {
      gitMode: false,
      repositories: null,
      editing: false,
      loading: false,
      repository: ''
    };
  }
};
</script>

<style scoped>

</style>
